import { styled, Stepper as MuiStepper, Step, StepLabel } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

import { useStepperData } from '../../contexts';

const RootContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  marginTop: theme.spacing(6),
  marginBottom: theme.spacing(9),
}));

const StyledStep = styled(Step)(({ theme }) => ({
  textAlign: 'center',
}));
interface IStepperProps {
  steps: string[];
  visibleLables: boolean;
  canChangeStep: boolean;
}

export const Stepper: FC<IStepperProps> = (props) => {
  const { steps, visibleLables, canChangeStep } = props;
  const {
    context: { stepperData },
  } = useStepperData();
  const { activeStep, setActiveStep, setManualChange } = stepperData;
  const { getTestIdProps } = useTestId();

  const handleChangeStep = (stepNumber: number) => {
    if (canChangeStep) {
      setManualChange(true);
      setActiveStep(stepNumber);
    }
  };

  const stepperWidth = steps.length > 1 ? `${steps.length * 130 - 75}px` : 'auto';

  return (
    <RootContainer>
      {steps.length > 1 && (
        <MuiStepper
          {...getTestIdProps('stepper')}
          activeStep={activeStep}
          style={{ width: stepperWidth }}
        >
          {steps.map((label, index) => (
            <StyledStep
              {...getTestIdProps('stepper-step')}
              key={label}
              onClick={() => handleChangeStep(index)}
            >
              <StepLabel {...getTestIdProps('stepper-step-label')}>
                {visibleLables ? <div {...getTestIdProps('stepper-step-label-text')}>label</div> : null}
              </StepLabel>
            </StyledStep>
          ))}
        </MuiStepper>
      )}
    </RootContainer>
  );
};
